<template>
    <router-link :to="{ name: 'premium' }" class="btn btn-gold w-100 cursor-pointer">
        <span>{{ translate.account.lockedProfile.upgradeToGold }}</span>
        <icon-component class="ml-2 h-100 upgrade-gold-icon" :icon="fa_stars_regular()"></icon-component>
    </router-link>
</template>

<script>
import {fa_stars_regular} from "@/core/constants/icons";
import IconComponent from "@/components/global/IconComponent.vue";

export default {
    components: {IconComponent},
    methods: {fa_stars_regular},
    computed: {
        ...mapState(['translate']),
    },
};
</script>
